import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'
import { find, map } from 'lodash'
import SubmissionError from '../../../../error/SubmissionError'

export const getAllCategories = ({ commit }) => {
  commit(types.SET_CATEGORIES_TOGGLE_LOADING)
  commit(types.SET_ERROR, '')

  return fetch('categories')
    .then(response => response.json())
    .then((data) => {
      commit(types.SET_CATEGORIES, data['hydra:member'])
    })
    .catch((e) => {
      commit(types.SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.SET_CATEGORIES_TOGGLE_LOADING)
    })
}

export const getAllTerritories = ({ commit }) => {
  commit(types.SET_TERRITORIES_TOGGLE_LOADING)
  commit(types.SET_ERROR, '')

  return fetch('territories')
    .then(response => response.json())
    .then((data) => {
      commit(types.SET_TERRITORIES, data['hydra:member'])
    })
    .catch((e) => {
      commit(types.SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.SET_TERRITORIES_TOGGLE_LOADING)
    })
}

export const getAllGames = ({ commit, state, dispatch }, page = null) => {
  commit(types.SET_GAMES_TOGGLE_LOADING)
  commit(types.SET_ERROR, '')

  let url = 'games?order[name]=asc'
  if (page) {
    url = page
  }

  return fetch(url)
    .then(response => response.json())
    .then((data) => {
      if (page) {
        commit(types.SET_GAMES, state.games.concat(data['hydra:member']))
      } else {
        commit(types.SET_GAMES, data['hydra:member'])
      }

      const moreGamesUrl = data['hydra:view']['hydra:next']
      if (moreGamesUrl) {
        return dispatch('getAllGames', moreGamesUrl)
      }
    })
    .catch((e) => {
      commit(types.SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.SET_GAMES_TOGGLE_LOADING)
    })
}

export const getOrderedGames = ({ commit, state, dispatch }, { categoryId, territorySlug, page = null }) => {
  commit(types.TOGGLE_LOADING)
  commit(types.SET_ERROR, '')

  let url = 'games/order?category=' + categoryId + '&territory=' + territorySlug
  if (page) {
    url = page
  }

  return fetch(url)
    .then(response => response.json())
    .then((data) => {
      if (page) { // Same category/territory - just fetching next bunch of games
        commit(types.SET_ITEMS, state.items.concat(data['hydra:member']))
      } else { // New category/territory selected
        commit(types.SET_ITEMS, data['hydra:member'])
      }

      const moreGamesUrl = data['hydra:view']['hydra:next']
      if (moreGamesUrl) {
        return dispatch('getOrderedGames', { categoryId, territorySlug, page: moreGamesUrl })
      }
    })
    .catch((e) => {
      commit(types.SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.TOGGLE_LOADING)
    })
}

export const saveOrderedGames = ({ state, commit }, { categoryId, territorySlug, gameList }) => {
  commit(types.TOGGLE_LOADING)
  commit(types.SET_ERROR, '')

  const category = find(state.categories, (category) => category.id === categoryId)
  const territory = find(state.territories, (territory) => territory.slug === territorySlug)
  const games = map(gameList, (game) => game['@id'])

  return fetch('games/order', {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/ld+json' }),
    body: JSON.stringify({ category: category['@id'], territory: territory['@id'], games })
  })
    .then(() => {
      commit(types.SET_ITEMS, gameList)
    })
    .catch((e) => {
      if (e instanceof SubmissionError) {
        commit(types.SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        commit(types.SET_ERROR, e.errors._error)
        return
      }

      commit(types.SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.TOGGLE_LOADING)
    })
}

export const resetOrderedGames = ({ commit }) => {
  commit(types.SET_ITEMS, [])
}
